import Page from "../../components/GlobalComponent/PageComponent";
import {AirTrackingBreadcrumb, ContainerTrackingBreadcrumb, MyInquiriesBreadcrumb} from "../../common/data/parties";
import StatsSummary from "../../components/GlobalComponent/StatsSummaryComponent";
import React, {useEffect, useState} from "react";
import SearchTracking from "./components/SearchTracking";
import SearchDetails from "./components/SearchDetails";
import AirSearchDetails from "./components/AirSearchDeatisl";
import TrackingTimelineModal from "./components/TrackingTimelineModal";
import {useFormik} from "formik";
import {useDispatch, useSelector} from "react-redux";
import {getTrackingDetails} from "../../store/Global/actions";
import {showErrorToast} from "../../components/Common/CustomToast";
import {useLoadingBar} from "../../components/Common/ProgressBar";
import * as Yup from "yup";
import SearchDetailsSkeleton from "./components/SearchDetailsSkeleton";
import AirSearchTracking from "./components/AirSearchTracking";

const AirTracking = () => {
    const { start, complete, decrease, increase } = useLoadingBar({ height: 3, });
    const [modalOpen, setModalOpen] = useState(false);
    const myInquiriesStatsData = [];
    const dispatch = useDispatch();
    const { trackingData } = useSelector((state) => state?.globalReducer);
    const [searchContainerData, setSearchContainerData] = useState({});
    const [searchEventData, setSearchEventData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const containerNumberSchema = Yup.string()
        .matches(/^[A-Z]{4}\d{7}$/, 'Expected format: 4 letters followed by 7 digits (e.g., MSCU1234567)')
        .required('Container number is required');

    const searchTrackingFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            trackingNumber: ''
        },
        // validationSchema: Yup.object().shape({
        //     trackingNumber: containerNumberSchema
        // }),
        onSubmit: (values) => {
            //console.log(values);
            setIsLoading(true);
            start();
            let payload = {
                containerId : values?.trackingNumber
            }
            dispatch(getTrackingDetails(payload));
        }
    });

    useEffect(() => {
        //console.log(trackingData, "trackingData");
        if (trackingData?.error?.code === 0) {
            setSearchContainerData(prevState => ({
                ...prevState,
                container: trackingData?.data?.container,
                pod: trackingData?.data?.pod,
                pol: trackingData?.data?.pol,
                origin: trackingData?.data?.origin,
                destination: trackingData?.data?.destination,
                timeStamp : trackingData?.data?.timestamp,
            }));
            setSearchEventData(trackingData?.data?.events || [])
        } else {
            setSearchContainerData({});
            setSearchEventData([]);
            showErrorToast(trackingData?.error?.text);
        }
        setTimeout(() => {
            setIsLoading(false);
            complete();
        }, 1500);
    }, [trackingData]);

    return(
        <Page>
            <StatsSummary
                breadcrumb={AirTrackingBreadcrumb}
                stats={myInquiriesStatsData}
            />
            <AirSearchTracking searchFormik={searchTrackingFormik} />
            {isLoading && (
                <SearchDetailsSkeleton />
            )}
            {(searchContainerData && Object.values(searchContainerData).some(val => val !== undefined) && !isLoading) && (
                <>
                    <AirSearchDetails
                        searchData={searchContainerData}
                        trackingEvents={searchEventData}
                        showHistory={() => setModalOpen(!modalOpen)}
                    />
                </>
            )}
        </Page>
    )
}

export default AirTracking;
